/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Report_Tab_StaffInputs */

const vi_report_tab_staff = /** @type {(inputs: Report_Tab_StaffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhân viên`)
};

/**

* @param {Report_Tab_StaffInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const report_tab_staff = /** @type {((inputs?: Report_Tab_StaffInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Tab_StaffInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_report_tab_staff(inputs)
});